export default {
    path: '/wecode/approval',
    auth: false,
    preload: false,
    key: 'form',
    isStatic: true,
    component: () => import('./index')
  };
  